import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function blockAffectedStaffPas(id: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.blockAffectedStaffPas.url, { id }))
    .post()
}
